// const noBorder = {
//   border: "none",
// };

// export { noBorder };
export const HomeStyle = {
  noBorder: {
    border: "none",
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
    mx: "12px",
    mt: "0px",
    mb: "6px",
    justifyContent: "space-between",
  },
  box: {
    flex: 1,
  },
  paper: {
    margin: "4px",
    padding: "8px",
    display: "flex",
    flexDirection: "row",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "10px",
  },
  hello: {
    fontWeight: "bold",
    alignText: "left",
    fontSize: "14px",
  },
  verifyInsurance: { flex: 1, m: 1, width: "100%", marginTop: "16px" },
  qrCode: { flex: 1, width: "100%", m: 1 },
  flexBox: {
    flex: 1,
    display: "flex",
  },
  flexPaper: {
    margin: "4px",
    paddingY: "12px",
    paddingX: "8px",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "10px",
    flex: 1,
    flexDirection: "column",
  },
  spaceBox: {
    display: "flex",
    flex: 2,
    justifyContent: "space-between",
    height: "100%",
  },
  evenlyBox: {
    flex: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
  },
  targerVerifications: { paddingLeft: "8px", fontWeight: "bold" },
  displayBox: {
    paddingRight: "12px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  content: {
    display: "flex",
    flex: 2,
    justifyContent: "center",
    height: "100%",
  },
  input: {
    flex: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
  },
  text: { paddingLeft: "8px", fontWeight: "bold" },
};

